import { gql } from '@apollo/client'

export const ReportEmbedQuery = gql`
    query getReportEmbedQuery($reportInput: GetEmbeddedReportInput!) {
        getEmbeddedAnalyticsReport(input: $reportInput) {
            embedReport {
                reportName
                embedUrl
            }
            embedToken {
                token
                expiration
            }
        }
    }
`
